module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('message-system', {
    attrs: {
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('grid-courses', {
    attrs: {
      "url": "courses/",
      "price": true,
      "teachers": true,
      "count": "4"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d82ccb0e","hasScoped":true}!./src/pages/courses/template.html
// module id = 428
// module chunks = 1